/**
 * Construit l'URL de la page de connexion en y préservant la destination
 * d'origine via un paramètre `?redirect=`. Login.jsx lit ce paramètre pour
 * renvoyer l'utilisateur vers la page initialement demandée après login.
 *
 * Cas d'usage typique : un lien dans un email (relance session, partage,
 * cadeau, etc.) cliqué hors session → l'utilisateur se connecte → retombe
 * exactement sur la même URL (params + hash inclus).
 *
 * Pages publiques ignorées (pas de boucle de redirection vers /connexion) :
 *   `/`, `/connexion`, `/inscription`.
 *
 * @param {object} [opts]
 * @param {string} [opts.reason] — code optionnel (`expired`, `session_replaced`)
 *                                 affiché en haut du formulaire de login.
 * @returns {string} URL absolue type "/connexion?redirect=...&reason=..."
 */
export function loginUrl(opts = {}) {
    const params = new URLSearchParams();
    if (typeof window !== 'undefined') {
        const path = window.location.pathname;
        const skip = path === '/connexion' || path === '/inscription' || path === '/';
        if (!skip) {
            params.set('redirect', path + window.location.search + window.location.hash);
        }
    }
    if (opts.reason) params.set('reason', opts.reason);
    const qs = params.toString();
    return qs ? `/connexion?${qs}` : '/connexion';
}
